// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Hkiu","footer":"ReportModalFilter_footer__fcnb6"};